module.exports = __webpack_public_path__ + "static/donation_package-47bee56f579d550ab058e80a847fa7c2.svg";